import { Linkedin, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-dark-bg text-dark-fg py-12 px-6">
      <div className="container mx-auto max-w-4xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 items-center text-center">
          <div className="flex flex-col items-center">
            <img src="/logo192.png" alt="Orbit" className="h-12 w-auto mb-6" />
            <div className="flex gap-4 justify-center">
              <a
                href="https://www.linkedin.com/company/orbitcablecam/"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin className="w-5 h-5 text-muted-foreground hover:text-primary cursor-pointer transition-colors" />
              </a>
              <a
                href="https://www.youtube.com/@ORBITcablecam"
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube className="w-5 h-5 text-muted-foreground hover:text-primary cursor-pointer transition-colors" />
              </a>
              <a
                href="https://www.instagram.com/orbitcablecam/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram className="w-5 h-5 text-muted-foreground hover:text-primary cursor-pointer transition-colors" />
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center">
            <h3 className="font-semibold mb-4 text-white">Get in touch</h3>
            <ul className="space-y-2 text-muted-foreground text-center">
              <li>info@orbitcablecam.com</li>
              <li>+46 (0) 73 928 86 89</li>
              {/* <li className="mt-6">Södra Gyllegatan 18</li> */}
              {/* <li>781 72 Borlänge</li> */}
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-muted-foreground">
          <p>© 2026 ORBIT Cable Cam. All rights reserved.</p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Shipping Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Accessibility
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
